import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import { Star, MapPin, ShieldCheck, MessageCircle } from "lucide-react";
import { CATEGORY_MAP } from "@/data/catalog";

export default function BusinessCard({ b }) {
  const cat = CATEGORY_MAP[b.category];
  const photo = b.photos?.[0] || cat?.image;
  return (
    <Link
      to={`/business/${b.slug || b.business_id}`}
      data-testid={`business-card-${b.business_id}`}
      className="group relative bg-white rounded-xl border border-slate-200 overflow-hidden card-hover flex flex-col"
    >
      <div className="relative aspect-[4/3] bg-slate-100 overflow-hidden">
        <img src={photo} alt={b.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />
        {b.verified && (
          <div className="absolute top-2 left-2 flex items-center gap-1 bg-emerald-800 text-white text-[11px] font-semibold px-2 py-1 rounded-full shadow">
            <ShieldCheck className="w-3 h-3" /> Verified
          </div>
        )}
        {b.featured && (
          <div className="absolute top-2 right-2 bg-amber-500 text-white text-[10px] font-bold uppercase tracking-wider px-2 py-1 rounded">Featured</div>
        )}
        <div className="absolute bottom-2 right-2 flex items-center gap-1 bg-white/95 text-slate-900 text-xs font-semibold px-2 py-1 rounded-full shadow-sm">
          <Star className="w-3 h-3 rating-star fill-current" />
          {b.avg_rating ? b.avg_rating.toFixed(1) : "New"}
          {b.review_count ? <span className="text-slate-500 font-normal">({b.review_count})</span> : null}
        </div>
      </div>
      <div className="p-3 sm:p-4 flex-1 flex flex-col">
        <div className="flex items-start justify-between gap-2">
          <h3 className="font-semibold text-sm sm:text-base text-slate-900 group-hover:text-emerald-800 transition-colors line-clamp-1">{b.name}</h3>
        </div>
        <div className="flex items-center gap-1 text-[11px] sm:text-xs text-slate-500 mt-1 truncate">
          <MapPin className="w-3 h-3 flex-shrink-0" /> {b.sector}
          {b.subcategory && <span className="mx-1">•</span>}
          {b.subcategory && <span className="capitalize truncate">{b.subcategory.replace(/_/g, " ")}</span>}
        </div>
        {b.description && <p className="hidden sm:block text-sm text-slate-600 mt-2 line-clamp-2">{b.description}</p>}
        <div className="mt-2 sm:mt-3 pt-2 sm:pt-3 border-t border-slate-100 flex items-center justify-between">
          {b.price_range && <Badge variant="secondary" className="bg-slate-100 text-slate-700 text-[10px] sm:text-xs">{b.price_range}</Badge>}
          {b.whatsapp && (
            <span className="ml-auto flex items-center gap-1 text-[11px] sm:text-xs font-semibold text-[#25D366]">
              <MessageCircle className="w-3.5 h-3.5" /> WhatsApp
            </span>
          )}
        </div>
      </div>
    </Link>
  );
}
